import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CountryPhoneCodes } from '../interface/country-phone-codes';

@Component({
  selector: 'app-editadmin',
  templateUrl: './editadmin.component.html',
  styleUrl: './editadmin.component.scss'
})
export class EditadminComponent {
   adminForm: FormGroup;
  isSubmitted = false;
  countryCodes: any = CountryPhoneCodes;
updatedAdmin:any;
  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<EditadminComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any) {
    this.adminForm = this.fb.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      country_code: ['+91', Validators.required],
      phone_number: [''],
      email: ['', [Validators.required, Validators.email]],
      optionType:['', Validators.required]
    });
  }
superadmin:any;
showedit:any;
sendotpemail:any;
sendotpphone:any;
optionType:any;
phoneInput: string = "";
  ngOnInit(): void {
    if (this.data) {
      this.updatedAdmin =this.data.admin;
      this.showedit = this.data.showChangePassword
      this.superadmin =this.updatedAdmin?.is_staff && this.updatedAdmin?.is_superuser
      if(this.data.profileData){
      this.sendotpemail =this.data.profileData.email
      this.sendotpphone = this.data.profileData.country_code + this.data.profileData.phone_number
      }
  if (this.updatedAdmin) {
      const isShip = this.updatedAdmin.is_shipped_admin;
      const isReceive = this.updatedAdmin.is_receiving_admin;

      if (isShip && isReceive) {
      this.optionType = "both";
    } else if (isShip) {
      this.optionType = "shipping";
    } else if (isReceive) {
      this.optionType = "receiving";
    } else {
      this.optionType = "";
    }
    }
 if (this.updatedAdmin.phone_number === "Not Available" || this.updatedAdmin.phone_number === "") {
    this.phoneInput = "NA";
  } else {
    this.phoneInput = this.updatedAdmin.phone_number;
  }

    }
    // Initialize form with existing admin data if needed
  }

  onKeyPress(event: KeyboardEvent): void {
    // Allow only numbers for phone number input
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  onWheel(event: WheelEvent): void {
    // Prevent changing number input value when scrolling
    event.preventDefault();
  }

  onUpdate(form: NgForm): void {
    this.isSubmitted = true;
     if (form.valid) {
     const phone = (!this.phoneInput || this.phoneInput === 'NA') ? '' : this.phoneInput;
       let isShipped = "false";
    let isReceiving = "false";

    if (this.optionType === "both") {
      isShipped = "True";
      isReceiving = "True";
    } 
    else if (this.optionType === "shipping") {
      isShipped = "True";
      isReceiving = "False";
    } 
    else if (this.optionType === "receiving") {
      isShipped = "False";
      isReceiving = "True";
    }

   const minimalPayload = {
      first_name: this.updatedAdmin.first_name,
      last_name: this.updatedAdmin.last_name,
      country_code: this.updatedAdmin.country_code,
      phone_number:  phone  === 'Not Available' ? '' : phone,
      is_shipped_admin: isShipped,
      is_receiving_admin: isReceiving
    };
    console.log('Form submitted:', minimalPayload);

    // Close modal and pass updated data to parent
    this.dialogRef.close(minimalPayload);
  }
  }

  onCancel(): void {
    // Implement modal close logic here
    this.dialogRef.close();
    console.log('Modal closed');
  }
  @ViewChild('countrySelect') countrySelect !: ElementRef;
  openDropdown(event: Event): void {
      event.preventDefault(); // Prevent any default behavior
      event.stopPropagation(); // Stop event bubbling to avoid conflicts
      this.countrySelect.nativeElement.click(); // Programmatically trigger click on the select element
    }
     onPhoneClick() {
    this.dialogRef.close('phone');
  }

  onEmailClick() {
    this.dialogRef.close('email');
  }
   selectedMethod: 'phone' | 'email' = 'phone'; // Default selection

  selectMethod(method: 'phone' | 'email') {
    this.selectedMethod = method;
  }
   get selectedValue(): string {
    return this.selectedMethod === 'phone' ? this.sendotpphone : this.sendotpemail;
  }

  get selectedLabel(): string {
    return this.selectedMethod === 'phone' ? 'Phone Number' : 'Email Address';
  }
  onSendClick() {
  if (this.selectedMethod === 'phone') {
    this.onPhoneClick();
  } else if (this.selectedMethod === 'email') {
    this.onEmailClick();
  }
}
allowOnlyLetters(event: KeyboardEvent) {
  const char = event.key;
  const regex = /^[a-zA-Z ]$/;
  if (!regex.test(char)) {
    event.preventDefault();  // numbers aur special characters block
  }
}
allowOnlyNumbers(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;
  // Allow only digits (0–9)
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}
}
